export type { Profession, GroupKey } from '../../../supabase/seed/specialties'
import type { Profession, GroupKey } from '../../../supabase/seed/specialties'

export interface SpecialtyOption {
  id: string
  profession: Profession
  groupKey: GroupKey
  nameUk: string
  nameEn: string
  aliases: string[]
  isOther: boolean
  countries: string[] | null
  mozLeaf: string | null
}

export type HealthcareRole = 'practitioner' | 'student' | 'adjacent' | 'none'
export const HEALTHCARE_ROLES: HealthcareRole[] = ['practitioner', 'student', 'adjacent', 'none']
export const MAX_SECONDARY_SPECIALTIES = 5

export const specialtyRequiredFor = (role: HealthcareRole | null) => role === 'practitioner'
export const specialtyHiddenFor = (role: HealthcareRole | null) => role === 'none'
